"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultExclusiveState = void 0;
var ExclusiveTranslateState_init_1 = require("@/pages/exclusive/states/ExclusiveTranslateState.init");
var ExclusiveProperty_init_1 = require("@/pages/exclusive/states/ExclusiveProperty.init");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var ExclusiveKeywordSuggestionType_1 = require("@/pages/exclusive/states/ExclusiveKeywordSuggestionType");
exports.defaultExclusiveState = {
    t: ExclusiveTranslateState_init_1.defaultExclusiveTranslateState,
    videoUrl: 'https://titan-live.s3.ap-southeast-1.amazonaws.com/website/common/videos/slideshow_desktop.mp4',
    videoUrlMobile: 'https://titan-live.s3.ap-southeast-1.amazonaws.com/website/common/videos/slideshow_mobile.mp4',
    soleAgentTotalCount: 8988,
    soleAgentForSaleCount: 5131,
    soleAgentForRentCount: 3843,
    searchKeyword: '',
    searchResultId: 0,
    searchResultType: ExclusiveKeywordSuggestionType_1.ExclusiveKeywordSuggestionType.Keyword,
    searchIsLoading: false,
    searchSuggestionGroups: [],
    searchSuggestionsActive: false,
    searchSuggestionGroupSelectedIndex: -1,
    searchSuggestionSelectedIndex: -1,
    searchPriceDropdownActive: false,
    searchPriceMin: 0,
    searchPriceMax: 0,
    searchPriceUnitIsMillion: true,
    searchTypeDropdownActive: false,
    searchType: SfilterTypeGroup_1.SfilterType.ALL,
    searchSortBy: 'updateddate-desc',
    resultCurrentPage: 1,
    resultTotalPage: 5,
    resultIsLoading: false,
    properties: [ExclusiveProperty_init_1.defaultExclusiveProperty, __assign(__assign({}, ExclusiveProperty_init_1.defaultExclusiveProperty), { isNoImage: true }), ExclusiveProperty_init_1.defaultExclusiveProperty, ExclusiveProperty_init_1.defaultExclusiveProperty, ExclusiveProperty_init_1.defaultExclusiveProperty, ExclusiveProperty_init_1.defaultExclusiveProperty],
    relatedProperties: [],
};
